import { render, staticRenderFns } from "./DeliveryRequestPartner.vue?vue&type=template&id=1131bcb0"
import script from "./DeliveryRequestPartner.vue?vue&type=script&lang=js"
export * from "./DeliveryRequestPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports